export const REQUESTED_CONVERSION_HISTORY = 'REQUESTED_CONVERSION_HISTORY';
export const requestedConversionHistory = () => ({
  type: REQUESTED_CONVERSION_HISTORY
});

export const RECEIVED_CONVERSION_HISTORY = 'RECEIVED_CONVERSION_HISTORY';
export const receivedConversionHistory = (conversionHistory) => ({
  type: RECEIVED_CONVERSION_HISTORY,
  conversionHistory
});

export const ERROR_CONVERSION_HISTORY = 'ERROR_CONVERSION_HISTORY';
export const errorConversionHistory = (error) => ({
  type: ERROR_CONVERSION_HISTORY,
  error
});
